/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { BREAKPOINTS } from '../../spacing/index.js';
import Footer from '../Footer/index.js';
import SideNav from '../SideNav/index.js';
import UtilityHeader from '../UtilityHeader/index.js';
import { ConnectedWrapper, SideNavWrapper, MainContainer, MainContent, MainWrapper } from './styledComponents.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';
import useMedia from '../../hooks/useMedia.js';

var _excluded = ["children", "footer", "header", "isSideNavOpen", "isStatic", "isWideMainNav", "sideNav"];
var Layout = function Layout(_ref) {
  var _theme$layout;
  var children = _ref.children,
    _ref$footer = _ref.footer,
    footer = _ref$footer === undefined ? /*#__PURE__*/jsx(Footer, {}) : _ref$footer,
    _ref$header = _ref.header,
    header = _ref$header === undefined ? /*#__PURE__*/jsx(UtilityHeader, {}) : _ref$header,
    _ref$isSideNavOpen = _ref.isSideNavOpen,
    isSideNavOpen = _ref$isSideNavOpen === undefined ? false : _ref$isSideNavOpen,
    _ref$isStatic = _ref.isStatic,
    isStatic = _ref$isStatic === undefined ? false : _ref$isStatic,
    _ref$isWideMainNav = _ref.isWideMainNav,
    isWideMainNav = _ref$isWideMainNav === undefined ? false : _ref$isWideMainNav,
    _ref$sideNav = _ref.sideNav,
    sideNav = _ref$sideNav === undefined ? /*#__PURE__*/jsx(SideNav, {}) : _ref$sideNav,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var isGlobal = ((_theme$layout = theme.layout) === null || _theme$layout === undefined ? undefined : _theme$layout.cds) === true;
  var isMobile = useMedia(["(max-width: ".concat(BREAKPOINTS.DESKTOP_SM, "px)")], [true], false);

  // We want the main content area to be "collapsed" in mobile view
  var isExpanded = isMobile ? false : isSideNavOpen;
  return isGlobal ? /*#__PURE__*/jsxs(ConnectedWrapper, {
    "data-testid": "main-wrapper-cds",
    children: [/*#__PURE__*/jsx(SideNavWrapper, {
      children: sideNav
    }), /*#__PURE__*/jsxs(MainContainer, {
      isExpanded: isExpanded,
      isStatic: isStatic,
      isWide: isWideMainNav,
      children: [header, /*#__PURE__*/jsx(MainContent, _objectSpread(_objectSpread({}, rest), {}, {
        children: children
      })), footer]
    })]
  }) : /*#__PURE__*/jsxs(Fragment, {
    children: [header, /*#__PURE__*/jsxs(MainWrapper, {
      "data-testid": "main-wrapper-can",
      children: [/*#__PURE__*/jsx(SideNavWrapper, {
        children: sideNav
      }), /*#__PURE__*/jsxs(MainContainer, {
        isExpanded: isExpanded,
        isStatic: isStatic,
        isWide: isWideMainNav,
        children: [/*#__PURE__*/jsx(MainContent, _objectSpread(_objectSpread({}, rest), {}, {
          children: children
        })), footer]
      })]
    })]
  });
};
process.env.NODE_ENV !== "production" ? Layout.propTypes = {
  /** Main content */
  children: PropTypes.node.isRequired,
  /** Footer */
  footer: PropTypes.node,
  /** UtilityHeader */
  header: PropTypes.node,
  /** Boolean to specify whether SideNav is open or closed */
  isSideNavOpen: PropTypes.bool,
  /** Whether SideNav is static (used alongside `shouldCloseOnBlur` prop) */
  isStatic: PropTypes.bool,
  /** Corresponding prop in SideNav (these MUST have the same value) */
  isWideMainNav: PropTypes.bool,
  /** SideNav */
  sideNav: PropTypes.node
} : undefined;
process.env.NODE_ENV !== "production" ? Layout.displayName = 'Layout' : undefined;

export { Layout as default };
